import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const IpiTooltip = () => (
    <CustomToolTip
        type="?"
        inverse
        place="right"
        info={
            <>
                <p style={{ fontSize: '1.3rem' }}>
                    An Interested Party Information (IPI) number is a unique identification number assigned to
                    songwriters, composers, and music publishers by their performance rights organization (PRO).
                </p>
                <br />
                <p style={{ fontSize: '1.3rem' }}>
                    Adding an IPI Number is optional, but it helps link you to your songs. You can find your IPI Number
                    by logging into your PRO's website or mobile app.
                </p>
            </>
        }
    />
)
export default IpiTooltip
